import React, { useContext, useEffect, useRef } from 'react';

import { connectHitInsights, connectHits } from 'react-instantsearch-dom';
import { HitsProvided } from 'react-instantsearch-core';

import { AppContext } from '../../../app';

import { addTrackingListenerToLink } from '../../../utils/segmentTracking';
import searchInsights from '../../../utils/insightsTracking';

import {
    AuctionCard,
    CreatorCard,
    DefaultCard,
    EventCard,
    LotCard,
    MarketplaceCard,
    MemberCard,
    MuseumCard,
} from '../../card_promos';

const HitsComponent = ({ hits }: HitsProvided<any>) => (
    <ul className="gridContent">
        {hits.map((hit: any) => {
            // Guarantee line supercedes artists and titles
            if (hit.guaranteeLine) {
                if (hit.guaranteeLine.indexOf('|') > -1) {
                    const guarantee = hit.guaranteeLine.split('|');
                    hit.artists = [guarantee[0]];
                    hit.title = guarantee[1];
                } else {
                    hit.title = hit.guaranteeLine;
                }
            }

            return <HitComponentWithInsights hit={hit} key={`item-algolia-${hit.objectID}`} />;
        })}
    </ul>
);

const HitComponent = ({ hit, insights }: any) => {
    const appContext = useContext(AppContext);

    // Once the list item ref has been set, use it to generically
    // apply tracking to any links contained within it
    const listItemRef = useRef(null);
    useEffect(() => {
        const links = listItemRef.current.querySelectorAll('a');
        links.forEach((link) => {
            // Ignore things like email links and telephone links
            if (link.href?.startsWith('http')) {
                // Segment click
                addTrackingListenerToLink({
                    link: link,
                    departments: hit.departments || [],
                    searchQuery: appContext.searchQuery,
                    tab: appContext.currentTab,
                    title: hit.title,
                    type: hit.type,
                });

                // Insights click
                link.addEventListener('click', () => {
                    insights('clickedObjectIDsAfterSearch', {
                        eventName: 'Search Result Clicked',
                    });
                });
            }
        });
    }, [listItemRef]);

    return (
        <li className="colMediumSpan4 colSmallSpan2 cardContainer" ref={listItemRef}>
            {(() => {
                switch (hit.promoType) {
                    case 'artist':
                        return <CreatorCard {...hit} />;
                    case 'auction':
                        return <AuctionCard {...hit} />;
                    case 'bid':
                        return <LotCard {...hit} />;
                    case 'brand':
                        return <CreatorCard {...hit} />;
                    case 'exhibition':
                        return <EventCard {...hit} />;
                    case 'lot':
                        return <LotCard {...hit} />;
                    case 'museum':
                        return <MuseumCard {...hit} />;
                    case 'retail':
                        return <MarketplaceCard {...hit} />;
                    case 'specialist':
                        return <MemberCard {...hit} />;
                    default:
                        return <DefaultCard {...hit} />;
                }
            })()}
        </li>
    );
};

// @ts-ignore: connectHitInsights isn't TypeScript-friendly
const HitComponentWithInsights = connectHitInsights(searchInsights)(HitComponent);

export const Hits = connectHits(HitsComponent);
